export default "__VITE_ASSET__dW$MYG1p__"